import { AES_KEY_BASE64_MAX_SIZE, AES_KEY_BASE64_MIN_SIZE } from '../constants';
import { base64Validator } from './base64';
export const aesKeyValidator = base64Validator({
    requiredError: 'internal.key.required',
    invalidFormatError: 'internal.key.base64',
    minLength: {
        min: AES_KEY_BASE64_MIN_SIZE,
        error: 'internal.key.minLength',
    },
    maxLength: {
        max: AES_KEY_BASE64_MAX_SIZE,
        error: 'internal.key.maxLength',
    },
});
